export default function init_data(IconsView, iconsViewCache) {

IconsView.prototype.loading = function (state) {
        const myself = this;
        this.isLoading = state;
        if (state) this.isLoadingDeep++;
        else this.isLoadingDeep--;
        const containers = myself.element.find('.iv__container');

        if (this.isLoadingDeep) {
            if (myself.view != 'tree' && myself.view != 'blocks') {
                if (containers.length) {
                    if (!containers.find('.iv__item--special-loading').length) {
                        myself.renderIcon(myself.options.sample.loading, containers);
                        myself.setIconSize();
                        containers.find('.iv__item--special-none').hide();
                    }
                } else {
                    if (this.options.sample) {
                        var tmpContainer = $('<div class="iv__container iv__container--tmp"></div>');
                        myself.renderIcon(this.options.sample.loading, tmpContainer);
                        this.element.find('.iv__view').append(tmpContainer);
                    }
                    else if (!this.element.find('.spinner').length) {
                        this.element.append('<div class="spinner"></div>');
                    }
                }
            }
            this.element.addClass('loading');
        } else {
            this.element.removeClass('loading');
            this.element.find('.spinner').remove();
            this.element.find('.iv__container--tmp').remove();
            if (containers) {
    	        containers.find('.iv__item--special-none').show();
    	        containers.find('.iv__item--special-loading').remove();
    	    }
        }
    };


IconsView.prototype.loadCache = function () {
        const myself = this;
        if (this.cache && iconsViewCache[this.cache]) {
            const data = jQuery.parseJSON(iconsViewCache[this.cache]);
            myself.loadAfter(data);
        } else {
            this.load();
        }
    };


IconsView.prototype.load = function () {
        const myself = this;

        if (this.element.data('url')) {
            this.dataMode = 'url';
            this.loadFromUrl(this.element.data('url'));
        } else if (this.element.data('field')) {
            this.dataMode = 'field';
            try {
                var currentData = this.dataField.val();
                if (currentData != this.dataJsonCache) {
                    this.dataJsonCache = currentData;
                    if ($.parseJSON(currentData) === '') {
                        this.dataClean = [];
                        currentData = [];
                    }
                    else {
                        this.dataClean = $.parseJSON(currentData);
                        currentData = $.parseJSON(currentData);
                    }
                    this.loadFromData(currentData);
                }
            } catch (err) {
                this.data = [];
            }
        } else if (this.data.length == 0) {
            this.dataMode = 'script';
            try {
                var currentData = $(this.element);
                if ($(this.element).find('script')) currentData = $(this.element).find('script');

                this.loadFromData($.parseJSON(currentData.html()));
            } catch (err) {
                this.data = [];
            }
        } else {
            this.dataMode = 'conf';
            myself.prepareData(myself.data, { childs: myself.data, type: 'root' });
            myself.loadPath(myself.path, true);
            myself.render();
            myself.timerLastLoad = 0;
            myself.timerLastLoadfull = 0;
        }
    };


IconsView.prototype.loadFromUrl = function (url) {
        const myself = this;
        this.loading(true);

        if (this.request) this.request.abort();
        this.request = $.ajax({
            url,
            type: 'get',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',

            success(data) {
                if (myself.cache) iconsViewCache[myself.cache] = JSON.stringify(data);
                if (data.queryCount && $('.queryCount').length) $('.queryCount').html(parseInt($('.queryCount').html()) + parseInt(data.queryCount));
                myself.data = data;
                myself.loadAfter(myself.data);
                if (myself.events.load) myself.events.load(myself);
                myself.element.trigger('iv:load', [data, myself]);
                myself.element.trigger('iconsview:load', [data, myself]);
            },
            error(data, status, error) {
                myself.events.error(status);
                myself.element.trigger('iv:error', [status, error, myself]);
                myself.element.trigger('iconsview:error', [status, error, myself]);
            },
            complete(data) {
                myself.loading(false);
            },
        });
    };


IconsView.prototype.loadFromData = function (data) {
        this.loadAfter(data);
    };


IconsView.prototype.loadAfter = function (data) {
        const myself = this;
        this.data = data;
        this.dataNode = null;

        if (this.dataClean) {
            for (let i = 0; i < data.length; i++) {
                data[i].dataClean = this.dataClean[i];
            }
        }

        if (this.data.options) this.options = this.data.options;
        if (this.data.templates) this.templates = this.data.templates;
        if (this.data.types) this.types = this.data.types;
        if (this.data.id) this.rootId = this.data.id;
        if (this.data.type) this.rootType = this.data.type;
        // Nouvelle structure normalisée : actions au niveau racine
        if (this.data.actions) {
            this.actions = this.data.actions;
        }
        // Rétro-compatibilité : actions dans options.actions (ancienne structure)
        else if (this.data.options && this.data.options.actions) {
            this.actions = this.data.options.actions;
        }
        if (this.data.data) this.data = this.data.data;


        myself.prepareOptions();

        if (data.status != 'error') {
            myself.prepareData(myself.data, { childs: myself.data, type: 'root' });

            if (myself.firstLoad) {
                // Utiliser le chemin parent si disponible
                if (myself.parent) {
                    let parentPath = myself.findPath(myself.parent, myself.parentType);
                    if (parentPath && parentPath.length > 0) {
                        myself.path = parentPath;
                    } else {
                        myself.path = [{ field: 'id', value: myself.parent }];
                    }
                }
                else if (myself.value && myself.valueType) {
                    let valuePath = myself.findPath(myself.value, myself.valueType);
                    
                    if (!valuePath) {
                        valuePath = myself.findPath(myself.value, null);
                    }
                    
                    if (valuePath && valuePath.length > 0) {
                        valuePath.pop();
                        myself.path = valuePath;
                    }
                }
            }

            myself.loadPath(myself.path, true);
            myself.render();
            myself.firstLoad = false;
            myself.timerLastLoad = 0;
            myself.timerLastLoadfull = 0;
        } else {
            if (myself.cache) iconsViewCache[myself.cache] = null;
            myself.events.error(data);
        }
    };


IconsView.prototype.quickLoad = function (node, returnData) {
        const myself = this;
        let hasBeenLoaded = false;
        if (node && returnData && returnData.meta) {
            if (node == this.dataNodeParent) {
                // debugger;
                if (!node.path) node.path = clone(this.path);
                returnData.meta.path = clone(node.path)
                returnData.meta.path.push(this.genPathNode(returnData.meta));
                if (node.childs !== undefined && node.childs.length > 0) node.childs.push(returnData.meta);
                else node.push(returnData.meta);
                myself.prepareData([returnData.meta], node, returnData.meta.path);
                myself.loadPath(myself.path, true);
                myself.render();
                hasBeenLoaded = true;
                //myself.render(node.childs);
            }
            else {
                const newItem = returnData.meta;
                if (myself.findItem(newItem.id, newItem.type, node.parent.childs)) {
                    let oldItem = myself.findItem(newItem.id, newItem.type, node.parent.childs);
                    $.each(returnData.meta, (index, data) => {
                        if (index != 'items') {
                            if (index != 'childs' || data.length > 0) oldItem[index] = data;
                        }
                    });
                    myself.prepareData([oldItem], oldItem.parent, oldItem.path);
                    myself.loadPath(myself.path, true);
                    myself.render();
                    hasBeenLoaded = true;
                }
                else if (newItem.parent && myself.findItem(newItem.parent.id, newItem.parent.type, node.parent.childs)) {
                    let newItemParent = myself.findItem(newItem.parent.id, newItem.parent.type, node.parent.childs)
                    newItemParent.childs.push(newItem);
                    myself.prepareData([newItem], newItemParent, newItem.path);
                    myself.loadPath(myself.path, true);
                    myself.render();
                    hasBeenLoaded = true;
                }

                /*
                $.each(returnData.meta, (index, data) => {
                    if (index != 'items') {
                        if (index != 'childs' || data.length > 0) node[index] = data;
                    }
                });
                myself.prepareData([node], node.parent, node.path);
                myself.loadPath(myself.path, true);
                myself.render();
                // this.render(node.parent.childs);
                */
            }
            if (myself.events.load) myself.events.load(myself);
        }

        // Fallback online reload
        if (!hasBeenLoaded) {
            if (!node) {
                node = this.dataNodeParent;
            } else if (node.parent) {
                node = node.parent
            }
            if (node && node.load) {
                this.lazyLoad(node);
            } else {
                this.load();
            }
        }
    };


IconsView.prototype.lazyLoad = function (node) {
        const myself = this;
        const { parent } = node;
        const { index } = node;

        if (node.load) {
            if (!node.isLoading) {
                node.isLoading = true;

                this.loading(true);

                if (this.request) {
                    this.request.abort();
                }
                this.request = $.ajax({
                    url: node.load,
                    type: 'get',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',

                    success(data) {
                        if (data.queryCount && $('.queryCount').length) $('.queryCount').html(parseInt($('.queryCount').html()) + parseInt(data.queryCount));

                        if (data.status != 'error') {
                            if (Array.isArray(data.data) && data.data.length > 0) {
                                if (data.data[0] && data.data[0].id == node.id) {
                                    // Case 1: Server returned container object wrapper
                                    const serverNode = data.data[0];
                                    const origChilds = node.childs;
                                    Object.assign(node, serverNode);
                                    if (serverNode.childs) node.childs = serverNode.childs;
                                    else if (origChilds) node.childs = origChilds;
                                } else {
                                    // Case 2: Server returned array of child items directly
                                    node.childs = data.data;
                                }
                                node.loaded = true;
                            } else {
                                node.loaded = true;
                                if (!Array.isArray(node.childs)) node.childs = [];
                            }

                            let parentData = node;

                            myself.dataNodeParent = parentData;
                            myself.dataNode = parentData.childs;

                            // restore parent option
                            const newParent = clone(myself.options.sample.parent);
                            newParent.id = null;
                            if (parent && parent.id) newParent.id = parent.id;
                            if (parent && parent.type && parent.type != 'root') newParent.type = parent.type;
                            else if (myself.rootType && parent && parent.type == 'root') {
                                newParent.type = myself.rootType;
                                newParent.id = myself.rootId;
                            }
                            newParent.special = 'parent';

                            if (parentData && parentData.childs) {
                                if (parentData.childs.length && (parentData.childs[0].special === 'parent' || parentData.childs[0].label === newParent.label)) {
                                    parentData.childs[0] = newParent;
                                } else {
                                    parentData.childs.unshift(newParent);
                                }
                            }

                            myself.prepareData(parentData.childs, parentData, myself.path);
                            myself.loadPath(null, true);
                            myself.render();
                            myself.timerLastLoad = 0;

                            if (myself.events.load) myself.events.load(myself);
                        } else {
                            myself.events.error(data);
                        }
                    },
                    error(data, status, error) {
                        node.isLoading = false;
                        myself.events.error(status);
                    },
                    complete(data) {
                        node.isLoading = false;
                        myself.loading(false);
                    },
                });
            }
        }
    }


IconsView.prototype.refreshTree = function () {
        const myself = this;
        this.element.find('.iv__item').each(function () {
            const item = $(this);
            if (item.find('.iv__item').length > 0) item.addClass('iv__item--parent');
            else item.removeClass('iv__item--parent');
        })
    }


IconsView.prototype.save = function () {
        if (this.element.data('field')) {
            this.dataJsonCache = null;
            this.dataField.val(JSON.stringify(this.dataClean)).change();
            this.load();
        }
    }


IconsView.prototype.update = function (data, path) {
        if (!path) {
            this.data = data;
        } else {
            _.set(this.dataClean, path, data);
            // _.set(this.data, path, data);
        }
        this.render();
        this.save();
    };


IconsView.prototype.prepareData = function (data, parentDataAll, path) {
        const myself = this;

        // no items
        if (parentDataAll.type == 'root' && data && Array.isArray(parentDataAll.childs) && myself.options.sample && myself.options.sample.root) {
            if (parentDataAll.childs.length && parentDataAll.childs[0] && parentDataAll.childs[0].special === 'root') {
                parentDataAll.childs[0] = clone(myself.options.sample.root);
            } else {
                parentDataAll.childs.unshift(clone(myself.options.sample.root));
            }
        }

        const parentData = parentDataAll;
        const currentData = data;
        if (!path) path = [];

        // actions remap
        if (parentDataAll) {
            if (!parentDataAll.actions) {
                parentDataAll.actions = {};
            }
            if (this.types[parentDataAll.type]) {
                if (this.types[parentDataAll.type].actions) {
                    mergeToObject(this.types[parentDataAll.type].actions, parentDataAll.actions);
                }

                if (!parentDataAll.default && this.types[parentDataAll.type].default && !parentDataAll.special) {
                    parentDataAll.default = this.types[parentDataAll.type].default;
                }
            }

            parentDataAll.actions = Object.assign({}, parentDataAll.actions);
            $.each(parentDataAll.actions, (indexAction, action) => {
                if (!action) return true;
                let replaceIndex = false;
                if (parseInt(indexAction) > 0 || parseInt(indexAction) === 0) replaceIndex = true;
                if (typeof action === 'string') {
                    // Résolution depuis le catalogue d'actions (nouvelle structure)
                    const actionCatalog = myself.actions || (myself.options && myself.options.actions);
                    if (actionCatalog && actionCatalog[action]) {
                        if (replaceIndex) {
                            delete parentDataAll.actions[indexAction];
                            indexAction = action;
                        }
                        parentDataAll.actions[indexAction] = actionCatalog[action];
                    } else {
                        delete parentDataAll.actions[indexAction];
                    }
                }
            });

            // no type, no actions use all defined actions
            const actionCatalog = myself.actions || (myself.options && myself.options.actions);
            if (!Object.keys(parentDataAll.actions).length && !parentDataAll.type && actionCatalog) {
                parentDataAll.actions = actionCatalog;
            }

        }

        if (data) {
            $.each(data, (index, data) => {
                if (data) {
                    data.index = index;
                    data.parent = parentData;
                    data.path = path;

                    // count resolution (si null explicite, ne rien calculer)
                    if (data.count !== null) {
                        const resolvedCount = myself.resolveItemCount(data);
                        if (resolvedCount !== undefined) {
                            data.count = resolvedCount;
                        }
                    }

                    // is selected
                    if (myself.firstLoad) {
                        $.each(myself.go, (selectionIndex, selectionItem) => {
                            // is selected
                            if (data.id && selectionItem.id == data.id && selectionItem.type == data.type && !data.special) {
                                myself.path = path;
                                myself.path.push({ field: 'id', value: data.id, type: data.type });
                            }
                        });

                        $.each(myself.selection, (selectionIndex, selectionItem) => {
                            if (myself.options.value) {
                                // compare value infos
                                if (data && data[myself.options.value] && data[myself.options.value] == selectionItem.id && !data.special) {
                                    if (data.id) {
                                        myself.selection[selectionIndex] = {
                                            id: data.id,
                                            type: data.type,
                                            data,
                                        };
                                    }
                                    data.selected = true;
                                    myself.path = path;
                                }
                            } else {
                                // is selected
                                if (data.id && selectionItem.id == data.id && selectionItem.type == data.type && !data.special) {
                                    data.selected = true;
                                    myself.path = path;
                                    selectionItem.data = data;
                                }
                            }
                        });
                    }


                    // childs process
                    if (data.childs) {
                        const newParent = clone(myself.options.sample.parent);
                        newParent.id = null;
                        if (parentData.id && parentData.type !== 'root') {
                            newParent.id = parentData.id;
                            newParent.type = parentData.type;
                        } else {
                            newParent.id = myself.rootId || null;
                            newParent.type = myself.rootType || 'character';
                        }
                        newParent.special = 'parent';
                        if (data.childs && data.childs.length && (data.childs[0].special === 'parent' || data.childs[0].label === newParent.label)) {
                            data.childs[0] = newParent;
                        }
                        else if (data.childs && data.childs.unshift) {
                            data.childs.unshift(newParent);
                        }
                        var currentPath = path.concat([{
                            field: 'id',
                            value: data.id,
                        }]);
                        myself.prepareData(data.childs, data, currentPath);
                    } else {
                        myself.prepareData(null, data, currentPath);
                    }
                }
            });
        }
    };


IconsView.prototype.prepareOptions = function () {
        if ((!this.options || !this.options.length) && this.conf.options) this.options = this.conf.options;
        if ((!Object.keys(this.templates).length) && this.conf.templates) this.templates = this.conf.templates;

        // Actions : initialiser depuis conf si pas déjà chargé depuis data
        if (!this.actions || !Object.keys(this.actions).length) {
            if (this.conf.actions) this.actions = this.conf.actions;
            else if (this.conf.options && this.conf.options.actions) this.actions = this.conf.options.actions;
            else this.actions = {};
        }

        for (const i in this.templates) {
            if (!this.templates[i].view || typeof this.templates[i].view !== 'object') {
                this.templates[i].view = {};
            }
            if (!this.templates[i].view.modes || !Array.isArray(this.templates[i].view.modes) || !this.templates[i].view.modes.length) {
                const instanceModes = this.modes || (this.options && (this.options.modes || this.options.views));
                if (instanceModes && Array.isArray(instanceModes) && instanceModes.length) {
                    this.templates[i].view.modes = [...instanceModes];
                } else {
                    const detectedModes = [];
                    const knownViews = ['table', 'mosaic', 'icons', 'thumbnails', 'list', 'tree', 'blocks', 'summary', 'cards', 'calendar', 'slideshow', 'preview'];
                    knownViews.forEach(v => {
                        if (this.templates[i].view[v]) detectedModes.push(v);
                    });
                    if (this.templates[i].view.default && !detectedModes.includes(this.templates[i].view.default)) {
                        detectedModes.unshift(this.templates[i].view.default);
                    }
                    this.templates[i].view.modes = detectedModes.length ? detectedModes : [
                        'icons',
                        'mosaic',
                        'thumbnails',
                        'list',
                        'table',
                        'summary',
                    ];
                }
            } else if (this.templates[i].view.default && !this.templates[i].view.modes.includes(this.templates[i].view.default)) {
                this.templates[i].view.modes.unshift(this.templates[i].view.default);
            }
        }

        // Configuration par défaut canonique pour l'objet options
        const defaultOptions = {
            template: 'default',
            event: {
                backup: null,
                leftClick: 'action',
                rightClick: 'menu',
                doubleClick: '',
                shiftClick: 'selectInt',
                ctrlClick: 'select',
                altClick: 'select1',
            },
            features: {
                lockSelection: false,
                breadcrumb: 'auto',
                sortable: false,
                droppable: false,
                reorganize: true,
                bgUnselect: true,
                tab: false,
                censor: false,
            },
            request: {},
            sample: {},
            remap: {
                label: ['label'],
                icon: ['icon'],
            },
            expand: false,
        };

        // Fusion en profondeur propre sans écraser les valeurs existantes
        if (!this.options || typeof this.options !== 'object') this.options = {};
        this.options.template = this.options.template || defaultOptions.template;
        this.options.event = $.extend({}, defaultOptions.event, this.options.event || {});
        this.options.features = $.extend({}, defaultOptions.features, this.options.features || {});
        this.options.request = $.extend({}, defaultOptions.request, this.options.request || {});
        this.options.sample = $.extend({}, defaultOptions.sample, this.options.sample || {});
        this.options.remap = $.extend({}, defaultOptions.remap, this.options.remap || {});
        if (this.options.expand === undefined) this.options.expand = defaultOptions.expand;

        if (this.isCensored === undefined) {
            this.isCensored = !!(this.options.features && this.options.features.censor);
        }
        if (this.isCensored) {
            this.element.addClass('iv--censored');
            if (this.containerView) this.containerView.addClass('iv--censored');
        }

        // Samples
        // Parent item
        const confParent = this.conf.parent || {};
        const confRoot = this.conf.root || {};
        const confNone = this.conf.none || {};
        const confLoading = this.conf.loading || {};
        const confDefault = this.conf.default || {};

        this.options.sample.parent = $.extend({
            id: 'parent',
            icon: confParent.icon || 'arrow-do-undo',
            label: confParent.label,
            selectable: false,
            type: 'parent',
            special: 'parent',
            default: 'parent',
            sticky: 100,
            actions: {
                parent: {
                    action: 'browseParent',
                    icon: confParent.icon || 'arrow-do-undo',
                    label: confParent.label,
                },
            },
        }, this.options.sample.parent || {});

        this.options.sample.root = $.extend({
            id: null,
            icon: confRoot.icon || 'place-home',
            label: confRoot.label,
            selectable: false,
            type: 'root',
            special: 'root',
            sticky: 200,
        }, this.options.sample.root || {});

        this.options.sample.none = $.extend({
            id: null,
            icon: confNone.icon || 'status-warning',
            label: confNone.label,
            selectable: false,
            type: 'none',
            special: 'none',
            sticky: 99,
        }, this.options.sample.none || {});

        this.options.sample.loading = $.extend({
            id: null,
            icon: confLoading.icon || 'fa-spinner-third',
            label: 'Chargement...',
            selectable: false,
            type: 'none',
            special: 'loading',
            sticky: 99,
        }, this.options.sample.loading || {});

        this.options.sample.default = $.extend({
            id: null,
            icon: confDefault.icon || 'file-page-empty',
        }, this.options.sample.default || {});

        // Events
        if (!this.data.events) this.data.events = {};
        this.events = {};
        if (this.conf.events) {
            const evNames = ['error', 'edit', 'refreshInput', 'render', 'change', 'load'];
            for (let k = 0; k < evNames.length; k++) {
                const evName = evNames[k];
                if (typeof this.conf.events[evName] === 'function') {
                    this.events[evName] = this.conf.events[evName];
                }
            }
        }

        // Misc
        if (!this.order && this.options.order) this.order = this.options.order;
    };


}
